import { CommandFunction, command, extension, PlainExtension } from 'remirror';
import { CueCommandsExtension } from './CueCommandsExtension';
import { ReplacementExtension } from './ReplacementExtension';

@extension({
  defaultOptions: {},
  staticKeys: [],
  handlerKeys: [],
  customHandlerKeys: [],
})
export class ClearMarksExtension extends PlainExtension {
  get name() {
    return 'clearMarks' as const;
  }

  /**
   * Removes cues and/or replacements.
   *
   * Replacement marks are removed outright, leaving the text they were applied to,
   * so nothing renderable is left behind when the section swaps to an avatar that
   * cannot render them.
   */
  @command()
  clearMarks(options?: {
    cues?: boolean;
    replacements?: boolean;
  }): CommandFunction {
    return props => {
      const { dispatch, tr, view } = props;
      const { cues, replacements } = options || {};
      const clearAll = cues === undefined && replacements === undefined;

      const cueCommandsExtension =
        this.store.getExtension(CueCommandsExtension);
      const replacementExtension =
        this.store.getExtension(ReplacementExtension);

      if (cues || clearAll) {
        const clearCuesCommand = cueCommandsExtension.clearCues();
        clearCuesCommand({ ...props, dispatch: undefined });
      }

      if (replacements || clearAll) {
        const removeReplacementsCommand =
          replacementExtension.removeReplacements();
        // Pass view and tr so the replacements are removed within the same transaction
        removeReplacementsCommand({
          ...props,
          view,
          tr,
          dispatch: undefined,
        });
      }

      if (dispatch) {
        dispatch(tr);
      }

      return true;
    };
  }
}

export default ClearMarksExtension;
